import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';

const defaultGap = css`
  grid-gap: 16px;

  @media ${from(Device.Tablet)} {
    grid-gap: 32px;
  }

  @media ${from(Device.Desktop)} {
    grid-gap: 28px;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-gap: 30px;
  }
`;

const base = css`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  max-width: 1920px;
  margin: auto;
`;

const defaultInnerStyles = css`
  ${base};
  ${defaultGap};
`;

const DefaultInner = styled.div`
  ${defaultInnerStyles};
`;

export const defaultPadding = css`
  --grid-padding: 16px;
  padding: 0px var(--grid-padding);

  @media ${from(Device.Tablet)} {
    --grid-padding: 40px;
  }

  @media ${from(Device.Desktop)} {
    --grid-padding: 32px;
  }

  @media ${from(Device.DesktopLarge)} {
    --grid-padding: 165px;
  }
`;

// Not using the padding shorthand here to allow padding-top & bottom overrides without resorting to !important
const reducedPadding = css`
  --grid-padding: 16px;
  padding-left: var(--grid-padding);
  padding-right: var(--grid-padding);

  @media ${from(Device.Tablet)} {
    --grid-padding: 32px;
  }

  @media ${from(Device.Desktop)} {
    --grid-padding: 28px;
  }

  @media ${from(Device.DesktopLarge)} {
    --grid-padding: 30px;
  }
`;

const DefaultStyles = css`
  ${base};
  ${defaultGap};
  ${defaultPadding};
`;

const Default = styled.div`
  ${DefaultStyles};
`;

const ReducedPaddingStyles = css`
  ${base};
  ${defaultGap};
  ${reducedPadding};
`;

const ReducedPadding = styled.div`
  ${ReducedPaddingStyles};
`;

export const Grid = {
  Default,
  DefaultStyles,

  DefaultInner,
  defaultInnerStyles,

  defaultGap,
  defaultPadding,

  reducedPadding,
  ReducedPadding,
  ReducedPaddingStyles,
};

const Full = styled.div`
  grid-column: span 12;
`;

const Half = styled.div`
  grid-column: span 6;
`;

const HalfToFull = styled.div`
  grid-column: span 12;

  @media ${from(Device.TabletLarge)} {
    grid-column: span 6;
  }
`;

const Third = styled.div`
  grid-column: span 4;
`;

const Quarter = styled.div`
  grid-column: span 3;
`;

const Container = styled.div`
  grid-column: span 12;

  @media ${from(Device.TabletLarge)} {
    grid-column: 2 / span 10;
  }
`;

const defaultBreakoutLeftStyles = css`
  margin-left: -16px;

  @media ${from(Device.Tablet)} {
    margin-left: -40px;
  }

  @media ${from(Device.Desktop)} {
    margin-left: -32px;
  }

  @media ${from(Device.DesktopLarge)} {
    margin-left: -165px;
  }
`;

const defaultBreakoutRightStyles = css`
  margin-right: -16px;

  @media ${from(Device.Tablet)} {
    margin-right: -40px;
  }

  @media ${from(Device.Desktop)} {
    margin-right: -32px;
  }

  @media ${from(Device.DesktopLarge)} {
    margin-right: -165px;
  }
`;

const defaultBreakoutStyles = css`
  ${defaultBreakoutLeftStyles};
  ${defaultBreakoutRightStyles};
`;

const DefaultGridBreakout = styled.div`
  grid-column: span 12;

  ${defaultBreakoutStyles};
`;

const reducedPaddingGridBreakoutStyles = css`
  margin-left: -16px;
  margin-right: -16px;

  @media ${from(Device.Tablet)} {
    margin-left: -32px;
    margin-right: -32px;
  }

  @media ${from(Device.Desktop)} {
    margin-left: -28px;
    margin-right: -28px;
  }

  @media ${from(Device.DesktopLarge)} {
    margin-left: -30px;
    margin-right: -30px;
  }
`;

const ReducedPaddingGridBreakout = styled.div`
  grid-column: span 12;

  ${reducedPaddingGridBreakoutStyles};
`;

export const Column = {
  Full,
  Half,
  HalfToFull,
  Third,
  Quarter,
  Container,

  DefaultGridBreakout,
  defaultBreakoutStyles,
  defaultBreakoutLeftStyles,
  defaultBreakoutRightStyles,

  ReducedPaddingGridBreakout,
  reducedPaddingGridBreakoutStyles,
};
